import etapes from "./dictionnaire/etapes";
import sousEtapes from "./dictionnaire/sousEtapes";

/**
 * le debounce permet d'appeler une fonction de callback après un temps défini
 * @param callback
 * @param delay
 * @returns {(function(): void)|*}
 */
export const debounce = (callback, delay = 500) => {
  let debounceTimer;
  return function () {
    const context = this;
    const args = arguments;
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => callback.apply(context, args), delay);
  };
};


export const groupeDeTrois = (value) => value ? value.replace(/\s/g, '').match(/.{1,3}/g).join(' ') : value;

export function getSousEtapeFromName(nomSousEtape) {
  return sousEtapes.sousEtapesPro.find(e => e.nom === nomSousEtape);
}

export function getNumeroEtape(etape, etapes) {
  return etapes.map(etape => etape.nom).indexOf(etape) + 1;
}

export function getTrackingObject({nomEtape, sousEtape, eventName, question = "" }, paramsSup) {
  return {
    event_name: eventName,
    question_label: question !== "" ? question : sousEtape?.question,
    question_id: `${getNumeroEtape(sousEtape.nom, sousEtapes.sousEtapesPro)}/${sousEtapes.sousEtapesPro.length}`,
    chapter_label: nomEtape,
    chapter_id: `${getNumeroEtape(nomEtape, etapes.etapesPro)}/${etapes.etapesPro.length}`,
    ...paramsSup
  }
}
